import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

const ProtectedRoute: React.FC = () => {
  const { isSignedIn, isLoaded } = useAuth();

  // Show loading state while Clerk is loading
  if (!isLoaded) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect to homepage if not authenticated
  return isSignedIn ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;
